import { combineReducers } from 'redux';

import emailsReducer from './emails';
import mainReducer from './main';

const reducers = combineReducers({
  emails: emailsReducer,
  main: mainReducer
});

export default reducers;
